<template>
  <div class="home">
    <div class="top">
      <!-- 顶部左侧 -->
      <div>
        <img class="img" :src="loginset.headerlogo" alt="">
      </div>
      <!-- 顶部右侧 -->
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <ul v-for="(item, index) in loginset.headerlink" :key="index">
          <el-link class="li" :underline="false" :href="item.url" target="_blank">{{ item.label }}</el-link>
        </ul>
      </div>
    </div>
    <div class="middle">
     <el-carousel  arrow="never" indicator-position="none" height="32.25rem" autoplay :interval="interval">
        <el-carousel-item v-for="(item, index) in loginset.bannerlist" :key="index">
          <img  alt="" class="bannerimg" :src="item">
        </el-carousel-item>
      </el-carousel>
      <div class="login">
        <i class="iconfont icon-erweima icon" v-if="showscanewm" @click="handleClick"></i>
        <div v-if="!isScan">
          <el-tabs v-model="activeName" class="tabs" @tab-click="changetab">
            <el-tab-pane name="login">
              <!-- 登录 -->
			  <span slot="label" :class="langtype=='cn'?'fontClass':''">{{$lang.label.public.login}}</span>
              <el-form :model="form" size="small">
                <el-form-item label="" prop="username">
                  <el-input v-model="form.account" ref="account" autocomplete="off" :placeholder="$lang.label.public.zhanghaotips" @keyup.native="val => enterinput(val,'password')"></el-input>
                </el-form-item>
                <el-form-item label="" prop="password">
                  <el-input type="password" ref="password" v-model="form.password" autocomplete="off" :placeholder="$lang.label.public.mimatips" @keyup.native="val => enterinput(val)"></el-input>
                </el-form-item>
                <el-form-item>
					<div style="padding-top:20px;">
						<el-button type="primary"  @click="gologinorregister" style="width: 100%;border-radius:30px"  :class="langtype=='cn'?'fontClassbtn':''">{{$lang.label.public.login}}</el-button>
					</div>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane name="register">
              <!-- 注册 -->
			  <span slot="label" :class="langtype=='cn'?'fontClass':''">{{$lang.label.public.register}}</span>
              <el-form :model="form" size="small">
                <el-form-item label="" prop="reaccount">
                  <el-input v-model="form.account" ref="reaccount" autocomplete="off" :placeholder="$lang.label.public.zhanghaotips" @keyup.native="val => enterinput(val,'repassword')"></el-input>
                </el-form-item>
                <el-form-item label="" prop="repassword">
                  <el-input type="password" ref="repassword" v-model="form.password" autocomplete="off"
                     :placeholder="$lang.label.public.mimatips" @keyup.native="val => enterinput(val,'shop')"></el-input>
                </el-form-item>
                <el-form-item label="" prop="shop" v-if="shoplist.length>1">
					 <el-select ref="shop" v-model="form.shop"  :placeholder="$lang.label.public.selectshop" @focus.prevent>
					   <el-option
						 v-for="item in shoplist"
						 :key="item.s_name"
						 :label="item.s_name"
						 :value="item.s_name"
					   >{{item.s_name}}</el-option>
					 </el-select>
                </el-form-item>
                <el-form-item style="margin-top:20px;">
					<div style="padding-top:20px;">
                  <el-button type="primary"  @click="gologinorregister" style="width: 100%;border-radius:30px" :class="langtype=='cn'?'fontClassbtn':''">{{$lang.label.public.register}}</el-button>
				   </div>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div v-else>
          <div style="position: absolute;right: 45%;">扫码登录</div>
          <div style="width: 200px;height: 200px; border: 1px solid red;position: relative;top: 30px;left: 85px;">

          </div>
          <div style="position: absolute;bottom:10px;left: 40px;">
            请使用微信/微博/QQ扫码安全登录
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
	<div class="foot">
		<div style="text-align: center;"  v-html="loginset.footerhtml"></div>
	</div>
  </div>
</template>

<script>
export default {
  name: 'login_dynamic',
  data() {
    return {
	  loginset:{
		 headerlogo: '',
		  headerlink: [
		  ],		 
		  bannerlist: [],
		 footerhtml: '' 
	  },
	  form: {
		account: '',
		password: '',
		shop: ''
	  },
	  shoplist: [],
      activeName: 'login',
      // 是否显示二维码
      showscanewm: true,
      //控制是否显示扫码登录界面
      isScan: false,
	  interval:5000,
	  verifyewm:'',
	  ewmid:'',
	  langtype:''
    }
  },
  mounted() {
	  this.langtype=this.$langtype;
  	//this.init();
  },
  methods: {
	init(){
		//加载首页配置信息
		var that=this;
		this.$apipost.get.GetLoginParam().then(res => {
			//debugger
			if(res!=''){
				that.loginset=res;
			}
			that.$refs.account.focus();
		}).catch(e=>{
			//that.init();
			this.$tool.message('打开异常，请刷新', 0);
		});
	},
	changetab(e){
		if(e.name=='register')
			 this.getshop();
		else
			this.activeName=e.name;
	},
    handleClick() {
       this.isScan = !this.isScan
    },
	getshop(){
		var that=this;
		if(that.shoplist.length==0){
			this.$apipost.get.GetGroup({ search: '', isshop: true, userid: '' }).then(res => {
				//console.log('注册门店',res);
				if (res.list != '') {
					that.shoplist = res.list;
					that.form.shop = that.shoplist[0].s_name;
					that.activeName = 'register';
				}
			});
		}else
			this.activeName = 'register';
	},
	enterinput(event,control){
		var that=this;
		if (event.keyCode != undefined) {
			if(event.keyCode==13){
				
				if(control!=undefined){
					if((control=='shop'&&that.shoplist.length>1)||(this.activeName=='login'&&control=='password')){
						this.$refs[control].focus();
					}
					else
						this.gologinorregister();
				}else
					this.gologinorregister();
			}
		}
	},
	gologinorregister(){
		if(this.activeName=='login'){
			//去登录
			this.$emit("Login", this.form);
		}
		else if(this.activeName=='register'){
			if(this.shoplist.length==1){
				this.form.shop=this.shoplist[0].s_name;
			}
			this.$emit("Register", this);
		}
	}
  }
}
</script>
<style lang="scss" scoped>
* {
  margin: 0;
}
.home {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top:30px;
  .top {
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px;

    .img {
      width: 193px;
	  height:auto;
    }

    .li {
      margin: 0 20px;
      display: block;
	  font-size:16px;
	  letter-spacing:1px;
    }
  }
  .middle {
    height: 70vh;
    position: relative;
    .login {
      border-radius: 10px;
      z-index: 999;
      width: 280px;
      min-height: 310px;
      background-color:#ffffff;
      position: absolute;
      top: 10%;
      right: 10%;
	  border-color:#a4a5a4;
      padding: 40px 20px 0 20px;
    }
	.bannerimg{
		width:100%;
		height:auto;
		min-height:430px;
	}
  }
  .foot {
	width:100%;
	position: relative;
	font-size:10pt;
	margin-top:30px;
  }
  /deep/ .el-input__inner {
       border-radius:20px;
	   margin-top:8px;
	   padding-left:20px;
	   padding-right:10px;
	}
}

.fontClass{
	font-size:18px;
	letter-spacing:10px;
}
.fontClassbtn{
	font-size:14px;
	letter-spacing:10px;
}
.icon {
  color: #00c89f;
  font-size: 40px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

::v-deep {
  .el-select {
    width: 100%;
  }
}
</style>
